wordmark: "banoffee"

links:
  - label: "Services"
    href: "#services"
  - label: "Projects"
    href: "#projects"
  - label: "Process"
    href: "#process"
  - label: "ROI"
    href: "#calculator"
  - label: "Book a Call"
    href: "#book"

buttons:
  ghost:
    label: "Discovery Call"
    href: "#book"
  primary:
    label: "Book a Call →"
    href: "#book"
